// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/graph/v1/signal_descriptor.proto (package mochabugapis.adapt.graph.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { SignalFormat, SignalFormatJson } from "./signal_format_pb";
import { file_mochabugapis_adapt_graph_v1_signal_format } from "./signal_format_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/graph/v1/signal_descriptor.proto.
 */
export const file_mochabugapis_adapt_graph_v1_signal_descriptor: GenFile = /*@__PURE__*/
  fileDesc("CjNtb2NoYWJ1Z2FwaXMvYWRhcHQvZ3JhcGgvdjEvc2lnbmFsX2Rlc2NyaXB0b3IucHJvdG8SG21vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC52MSKPAgoQU2lnbmFsRGVzY3JpcHRvchIzCgRuYW1lGAEgASgJQiW6SCJyIBABGDIyGl5bXyRhLXpBLVpdW18kYS16QS1aMC05XSokEhwKBWxhYmVsGAIgASgJQgi6SAVyAxj6AUgAiAEBEiIKC2Rlc2NyaXB0aW9uGAMgASgJQgi6SAVyAxjoB0gBiAEBEhUKCG9wdGlvbmFsGAQgASgISAKIAQESRgoHZm9ybWF0cxgFIAMoCzIpLm1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC52MS5TaWduYWxGb3JtYXRCCrpIB5IBBAgBEDJCCAoGX2xhYmVsQg4KDF9kZXNjcmlwdGlvbkILCglfb3B0aW9uYWxiBnByb3RvMw", [file_buf_validate_validate, file_mochabugapis_adapt_graph_v1_signal_format]);

/**
 * SignalDescriptor defines the complete specification of a signal, including its identity
 * and data format, without containing the actual signal data.
 *
 * A signal descriptor represents what a signal IS - its name, documentation, and the
 * single, specific format it produces. This is distinct from SignalBinding, which
 * represents what formats a binding point ACCEPTS.
 *
 * @generated from message mochabugapis.adapt.graph.v1.SignalDescriptor
 */
export type SignalDescriptor = Message<"mochabugapis.adapt.graph.v1.SignalDescriptor"> & {
  /**
   * Identifier for the signal, following ECMAScript identifier naming conventions.
   * Must be a valid JavaScript/TypeScript identifier to ensure compatibility with
   * code generation and scripting environments.
   *
   * Pattern: Must start with letter, $, or _, followed by letters, digits, $, or _
   * Length: 1-50 characters
   *
   * Examples: "temperature", "user_id", "$internal", "_privateSignal"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Human-readable label for the signal, suitable for display in user interfaces.
   * Should be brief and descriptive.
   *
   * Length: Up to 250 characters
   *
   * Examples: "Room Temperature", "User ID", "Processing Status"
   *
   * @generated from field: optional string label = 2;
   */
  label?: string | undefined;

  /**
   * Detailed description of the signal's purpose, behavior, and usage.
   * Should provide context for developers and users.
   *
   * Length: Up to 1000 characters
   *
   * May include:
   * - What the signal represents
   * - When it's emitted
   * - Expected value ranges or formats
   * - Usage examples or constraints
   *
   * @generated from field: optional string description = 3;
   */
  description?: string | undefined;

  /**
   * Indicates whether this signal must be provided.
   *
   * When false or unset: Signal is required and must be present
   * When true: Signal is optional and may be omitted
   *
   * Optional signals provide flexibility in graph construction, allowing
   * vertices to function with or without certain inputs.
   *
   * @generated from field: optional bool optional = 4;
   */
  optional?: boolean | undefined;

  /**
   * List of formats that this signal produces. The signal will produce any signal whose
   * format matches at least one entry in this list.
   *
   * Validation: At least one format must be specified. Maximum 50 formats to prevent
   * overly complicated signals and ensure reasonable validation performance.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.SignalFormat formats = 5;
   */
  formats: SignalFormat[];
};

/**
 * SignalDescriptor defines the complete specification of a signal, including its identity
 * and data format, without containing the actual signal data.
 *
 * A signal descriptor represents what a signal IS - its name, documentation, and the
 * single, specific format it produces. This is distinct from SignalBinding, which
 * represents what formats a binding point ACCEPTS.
 *
 * @generated from message mochabugapis.adapt.graph.v1.SignalDescriptor
 */
export type SignalDescriptorJson = {
  /**
   * Identifier for the signal, following ECMAScript identifier naming conventions.
   * Must be a valid JavaScript/TypeScript identifier to ensure compatibility with
   * code generation and scripting environments.
   *
   * Pattern: Must start with letter, $, or _, followed by letters, digits, $, or _
   * Length: 1-50 characters
   *
   * Examples: "temperature", "user_id", "$internal", "_privateSignal"
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * Human-readable label for the signal, suitable for display in user interfaces.
   * Should be brief and descriptive.
   *
   * Length: Up to 250 characters
   *
   * Examples: "Room Temperature", "User ID", "Processing Status"
   *
   * @generated from field: optional string label = 2;
   */
  label?: string;

  /**
   * Detailed description of the signal's purpose, behavior, and usage.
   * Should provide context for developers and users.
   *
   * Length: Up to 1000 characters
   *
   * May include:
   * - What the signal represents
   * - When it's emitted
   * - Expected value ranges or formats
   * - Usage examples or constraints
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * Indicates whether this signal must be provided.
   *
   * When false or unset: Signal is required and must be present
   * When true: Signal is optional and may be omitted
   *
   * Optional signals provide flexibility in graph construction, allowing
   * vertices to function with or without certain inputs.
   *
   * @generated from field: optional bool optional = 4;
   */
  optional?: boolean;

  /**
   * List of formats that this signal produces. The signal will produce any signal whose
   * format matches at least one entry in this list.
   *
   * Validation: At least one format must be specified. Maximum 50 formats to prevent
   * overly complicated signals and ensure reasonable validation performance.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.SignalFormat formats = 5;
   */
  formats?: SignalFormatJson[];
};

/**
 * Describes the message mochabugapis.adapt.graph.v1.SignalDescriptor.
 * Use `create(SignalDescriptorSchema)` to create a new message.
 */
export const SignalDescriptorSchema: GenMessage<SignalDescriptor, {jsonType: SignalDescriptorJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_v1_signal_descriptor, 0);

